export default __webpack_public_path__ + "static/media/pinguinMobile.a7a01883.png";